export const ClientId = "culmia";
export const ClientName = "Culmia";

export const DefaultConfig = {
    locale: "es"
};
export const MobileWidth = 1200;
export const MobilePortraitHeight = 600;

export const ClientBaseUrl = "https://culmia-config.bizionar.digital";
// export const ClientBaseUrl = "http://localhost:3000";
// export const ClientBaseUrl = "http://192.168.10.122:3000";

export const ServerBaseUrl = "https://culmia-configurator-api.bizionar.digital/v1";
// export const ServerBaseUrl = "http://localhost:5280/v1";
// export const ServerBaseUrl = "http://192.168.10.122:5280/v1";

export const EndPoints = {
    UserUrl: ServerBaseUrl + '/user',
    LoginUrl: ServerBaseUrl + '/user',
    LogoutUrl: ServerBaseUrl + '/user',
    SetPasswordUrl: ServerBaseUrl + '/user',
    LoadConfigUrl: ServerBaseUrl + '/configuration',
    LoadConfigCodeUrl: ServerBaseUrl + '/configuration',
    LoadPublicConfigUrl: ServerBaseUrl + '/configuration-public',
    SaveConfig: ServerBaseUrl + '/configuration',
    RequestBudget: ServerBaseUrl + '/configuration',
    UnitUsersUrl: ServerBaseUrl + '/promotion',
    DownloadPdf: ServerBaseUrl + '/configuration',
    Generation: ServerBaseUrl + '/configuration',
    PublicGeneration: ServerBaseUrl + '/configuration-public',
    PublicDownloadPdf: ServerBaseUrl + '/configuration-public',
}

export const UnitStatus = {
    BudgetNotRequested: 'BudgetNotRequested',
    BudgetRequested: 'BudgetRequested',
    BudgetSigned: 'BudgetSigned',
    BudgetRequestedAdmin: 'BudgetRequestedAdmin',
    BudgetNotRequestedIgnoreDate: 'BudgetNotRequestedIgnoreDate',
    BudgetRequestInProcess: 'BudgetRequestInProcess'
};

export const ApplicationState = {
    NotInitialized: 'NotInitialized',
    RequestBudgetNotStarted: 'RequestBudgetNotStarted',
    UserLoggedOut: 'UserLoggedOut',
    UserLoginFailed: 'UserLoginFailed',
    UserSetPasswordRequired: 'UserSetPasswordRequired',
    UserLoggedIn: 'UserLoggedIn',
    UserSelectFromMultipleUnitsRequired: 'UserSelectFromMultipleUnitsRequired',
    PromotionLoaded: 'PromotionLoaded',
    Ready: 'Ready',
};

export const PopupState = {
    None: 'None',
    Login: 'Login',
    Logout: 'Logout',
    UnitSelector: 'UnitSelector',
    Rules: 'Rules',
    LoadConfiguration: 'LoadConfiguration',
    SaveConfiguration: 'SaveConfiguration',
    RequestBudget: 'RequestBudget',
    LegalNote: 'LegalNote'

};

export const UserStatus = {
    LoggedOut: 'LoggedOut',
    LoggedIn: 'LoggedIn',
    SetPasswordRequired: 'SetPasswordRequired'
};

export const PromotionStatus = {
    Review: "Review",
    Live: "Live",
    RequestBudgetStarted: "RequestBudgetStarted",
    RequestBudgetEnded: "RequestBudgetEnded"
};

export const RequestBudgetStatus = {
    RequestBudgetNotStarted: 'RequestBudgetNotStarted',
    RequestBudgetStarted: 'RequestBudgetStarted',
    RequestBudgetEnded: 'RequestBudgetEnded'
};

export const UserAccessError = {
    InvalidToken: 'InvalidToken',
    UnitNotFound: 'UnitNotFound'
}

export const MyProfileState = {
    MyConfigurations: 'my-configurations',
    MyAccount: 'my-account',
    Closed: ''
}

export const FeedbackMessages = {
    DisabledInDemo: 'Función deshabilitada en la demo',
    LoginSuccess: 'Sesión iniciada con éxito',
    LoginError: 'Error al iniciar sesión',
    LogoutSuccess: 'Sesión cerrada con éxito',
    LogoutError: 'Error al cerrar sesión',
    RequestBudgetSuccess: 'Configuración formalizada con éxito.',
    RequestBudgetError: 'Se ha producido un error al formalizar.',
    CodeCopiedToClipboard: 'Código copiado en el portapapeles',
    ConfigurationCodeLoadedSuccesfully: 'Se ha cargardo con éxito la configuración',
    ConfigurationCodeNotFound: 'El código de configuración no existe',
    RequestBudgetEndDate: 'El proceso de formalización finaliza el: ',
    RequestBudgetEnded: 'El proceso de formalización ha finalizado',
    SavingConfiguration: "Guardando configuración...",
    Loading: "Cargando...",
    ErrorSavingConfiguration: "Error guardando configuración",
    GeneratingPdf: "Generando PDF...",
    GeneratingPdfSubtitle: "Este proceso puede tardar unos segundos",
    RequestingBudget: "Formalizando Configuración..."
}

export const Language = {
    es: 'es',
    en: 'en',
    ca: 'ca'
};
